module.exports = __webpack_public_path__ + "img/avatar.b8489970.png";